import React from 'react';
import {Typography} from "@mui/material";

const SettingsContactInfo = () => {
    return (
        <div>
            <Typography
                variant="h6"
                component="h1"
                sx={{
                    marginBottom: '1em',
                    color:'#333333'
                }}

            >Settings Contact Info</Typography>
            {/* Your component code goes here */}
        </div>
    );
};

export default SettingsContactInfo;
